function modules() {
  const registerModules = [];

  return {
    registerModule(moduleInfo) {
      registerModules.push(moduleInfo);
    },
    $get() {
      return registerModules;
    }
  };
}

export default modules;
